var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38ZM24.4594 34.6578L24.6055 35.0887C34.8361 32.0721 38.6361 22.3039 36.0053 13.254L35.4207 13.3977C34.9823 11.2429 33.0823 8.94456 31.6208 7.36442L32.3516 6.50252C28.9901 3.19859 24.7517 1.33115 19.9287 1.1875L19.6363 2.62399C18.321 2.62399 16.421 2.76764 15.2518 3.19859L15.1056 2.62399C11.3057 3.48589 8.52882 5.49698 6.92115 7.65171L6.04424 6.78982C2.53659 10.381 0.928924 15.6961 1.22123 20.4365H2.53659C2.53659 21.442 2.97505 23.4531 3.4135 24.6023L3.99811 24.4587C4.72887 26.7571 6.48269 29.0554 7.94421 30.4919L6.77499 31.7848C10.1365 35.0887 14.9595 36.8125 19.6363 36.8125L19.7825 35.376C21.2932 35.511 22.6749 35.1386 24.1701 34.7356C24.266 34.7097 24.3624 34.6837 24.4594 34.6578Z",
    fill: "url(#paint0_linear_12328_14964)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12328_14964",
    x1: 38,
    y1: -0.0000144477,
    x2: -0.0000144477,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48F7BA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498206,
    stopColor: "#4EF076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48F7BA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoder);
export default __webpack_public_path__ + "static/media/Boder.c1632e4de787159f03edabc68ad4024d.svg";
export { ForwardRef as ReactComponent };